import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { API } from '../utils/apiInstance';

// Create Order
export const addProduct = createAsyncThunk(
    'order/addProduct',
    async (formData, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await API.post('/product/add', formData);

            console.log(data);
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message || error?.message || 'unknown error'
            );
        }
    }
);

export const getProducts = createAsyncThunk(
    'order/getProducts',
    async (_, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await API.get('/product/get');

            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message || error?.message || 'unknown error'
            );
        }
    }
);

export const deleteProduct = createAsyncThunk(
    'order/deleteProduct',
    async (id, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await API.delete(`/product/delete?id=${id}`);
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message || error?.message || 'unknown error'
            );
        }
    }
);

export const getSingleProductDetails = createAsyncThunk(
    'order/getSingleProductDetails',
    async (id, { fulfillWithValue, rejectWithValue }) => {
        try {
            const { data } = await API.get(`/product/details?id=${id}`);
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(
                error?.response?.data?.message || error?.message || 'unknown error'
            );
        }
    }
);

const initialState = {
    isLoading: false,
    error: null,
    success: null,
    products: null,
    productDetails: null,
    message: null,
};

export const productSlice = createSlice({
    name: 'product',
    initialState,
    extraReducers: (builder) => {
        // Save Product
        builder.addCase(addProduct.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        });

        builder.addCase(addProduct.fulfilled, (state, action) => {
            state.isLoading = false;
            state.message = 'Product added successfully';
        });

        builder.addCase(addProduct.rejected, (state, action) => {
            state.isLoading = false;
        });

        // Get Products
        builder.addCase(getProducts.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        });

        builder.addCase(getProducts.fulfilled, (state, action) => {
            state.isLoading = false;
            state.products = action.payload.products;
        });

        builder.addCase(getProducts.rejected, (state, action) => {
            state.isLoading = false;
        });

        // Delete Product
        builder.addCase(deleteProduct.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        });

        builder.addCase(deleteProduct.fulfilled, (state, action) => {
            state.isLoading = false;
            state.products = action.payload.data;
            state.message = 'Product deleted successfully';
        });

        builder.addCase(deleteProduct.rejected, (state, action) => {
            state.isLoading = false;
        });

        // Get Single Product Details
        builder.addCase(getSingleProductDetails.pending, (state) => {
            state.isLoading = true;
            state.error = null;
        });

        builder.addCase(getSingleProductDetails.fulfilled, (state, action) => {
            state.isLoading = false;
            state.productDetails = action.payload.data;
        });

        builder.addCase(getSingleProductDetails.rejected, (state, action) => {
            state.isLoading = false;
        });
    },
});
export default productSlice.reducer;
